import { render, staticRenderFns } from "./sidebarlogo.vue?vue&type=template&id=9f9987c8&scoped=true&"
import script from "./sidebarlogo.vue?vue&type=script&lang=ts&"
export * from "./sidebarlogo.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarlogo.vue?vue&type=style&index=0&id=9f9987c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9987c8",
  null
  
)

export default component.exports